import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-email-viewer',
	templateUrl: './email-viewer.component.html',
	styleUrls: ['./email-viewer.component.scss']
})
export class EmailViewerComponent implements OnInit {

	body: any = '';

	constructor(private activeModal: NgbActiveModal) { }

	ngOnInit() {
	}

	close(): void {
		this.activeModal.close(true);
	}

	dismiss(): void {
		this.activeModal.dismiss();
	}

}
